import React from 'react';
import Header from './components/Header';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Team from './components/Team';
import Reviews from './components/Reviews';
import FacebookPosts from './components/FacebookPosts';
import BeforeAfter from './components/BeforeAfter';
import Location from './components/Location';
import FAQ from './components/FAQ';
import Appointment from './components/Appointment';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div>
      <Header />
      <AboutUs />
      <Services />
      <Team />
      <Reviews />
      <FacebookPosts />
      <BeforeAfter />
      <Location />
      <FAQ />
      <Appointment />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
